module.exports = __webpack_public_path__ + "img/top_img01.825a968c.jpg";